import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const NewShift = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content newShifts_ms">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <div class="row mx-0">
                <h4 class="event-alert">Ingredient Info </h4>
                <div class="col-md-6 px-0 px-sm-3">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label class="">Use Template </label>
                      <div class="input-group select-div mb10">
                        <select
                          name="category_id"
                          class="required"
                          id="IngredientCategoryId"
                        >
                          <option value="">Select</option>
                          <option value="2">Poultry</option>
                          <option value="3">Seafood</option>
                        </select>{" "}
                      </div>
                    </li>
                    <li>
                      <label class="required">Function</label>
                      <div class="input-group select-div mb-2">
                        <select
                          name="category_id"
                          class="required"
                          id="IngredientCategoryId"
                        >
                          <option value="">Select</option>
                          <option value="2">Poultry</option>
                          <option value="3">Seafood</option>
                        </select>{" "}
                      </div>
                    </li>
                    <li>
                      <label class="required">Recurring Shift?</label>
                      <div class="input-group select-div mb-2">
                        <select
                          name="measurement_unit_id"
                          class="required"
                          id="MPrice0MeasurementUnitId"
                        >
                          <option value="">Select</option>
                          <option value="1">Kilograms</option>
                          <option value="2">Milligrams</option>
                        </select>{" "}
                      </div>
                    </li>
                    <li>
                      <label class="required">Account</label>
                      <div class="input-group select-div mb10 ">
                        <select
                          name="non_cogs"
                          class="required"
                          id="IngredientNonCogs"
                        >
                          <option value="">Select</option>
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </select>{" "}
                      </div>
                    </li>
                    <li>
                      <label class="required">Shift Date</label>
                      <div class="input-group"></div>
                    </li>

                    <li>
                      <label class="required">Shift Time Range</label>
                      <div class="input-group"></div>
                    </li>

                    <li>
                      <label class="">Unpaid Break Time Range</label>
                      <div class="input-group"></div>
                    </li>
                  </ul>
                  <ul class="total-hours">
                    <li>
                      <label> Shift Hours | </label>
                      <span id="shift_range_id">
                        <strong>0 Hours</strong>
                      </span>
                    </li>
                    <li>
                      <label> Unpaid Hours | </label>
                      <span id="unpaid_break_range_id">
                        <strong>0 Hours</strong>
                      </span>
                    </li>
                    <li class="green-txt">
                      <label> Total Hours | </label>
                      <span id="total_hour_range_id">
                        <strong>0 Hours</strong>
                      </span>
                    </li>
                  </ul>
                </div>

                <div class="col-md-6 px-0 px-sm-3">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label>Employee Confirmed For Shift?</label>
                      <div class="input-group select-div">
                        <select
                          name="storage_area_2_id"
                          class=""
                          id="StorageArea2Id"
                        >
                          <option value="">Select</option>
                          <option value="1">New Area</option>
                        </select>{" "}
                      </div>
                    </li>
                    <li>
                      <label>Notes</label>
                      <div class="input-group">
                        <textarea
                          name="notes"
                          class=""
                          cols="45"
                          rows="5"
                          id="IngredientNotes"
                        ></textarea>{" "}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="btn-sec-row clearfix">
              <input
                class="btn cancel"
                type="button"
                value="Cancel"
                id="cancel"
              />
              <input
                class="btn bordered-btn"
                type="submit"
                value="Add As Template"
                id="saveTemplate"
              />
              <input
                class="btn green-btn-revert"
                type="submit"
                value="Create"
                id="submitBut"
              />
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default NewShift;
